export default __webpack_public_path__ + "static/media/telxl_logo_b_blue.6bbe8ad5.svg";